"use client";
import { faAngleLeft, FontAwesomeIcon } from "@/constants/icons";
import React, { useEffect, useState } from "react";

const ScrollButtonLeft = ({ sectionType }: { sectionType: string }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      const container = document.querySelector(
        `.horizontal-scroll-${sectionType}`,
      ) as HTMLElement | null;

      if (container) {
        setVisible(container.scrollWidth > container.clientWidth + 5);
      }
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);

    return () => window.removeEventListener("resize", checkOverflow);
  }, [sectionType]);

  if (!visible) return null;

  return (
    <button
      className="bg-blue-600 text-white w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full shadow-[0_10px_20px_rgba(55,48,163,0.3)] border border-white/10 hover:scale-110 hover:bg-blue-700 transition-all duration-300 cursor-pointer"
      onClick={() => {
        const container = document.querySelector(
          `.horizontal-scroll-${sectionType}`,
        );
        if (container) {
          const containerWidth = container.getBoundingClientRect().width;
          container.scrollBy({ left: -containerWidth, behavior: "smooth" });
        }
      }}
      aria-label="Scroll Left"
    >
      <FontAwesomeIcon
        icon={faAngleLeft}
        className="w-4 h-4 md:w-5 md:h-5"
        style={{ color: "currentColor" }}
      />
    </button>
  );
};

export default ScrollButtonLeft;
